"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationResponse = void 0;
var ValidationResponse;
(function (ValidationResponse) {
    ValidationResponse["ACCOUNT_NUMBER_INVALID"] = "invalidAccountNum";
    ValidationResponse["ACCOUNT_ROUTING_INVALID_NOMATCH"] = "accountAndRoutingNoMatch";
    ValidationResponse["ADDRESS_INVALID_LONG"] = "invalidAddressLong";
    ValidationResponse["ADDRESS_INVALID_POBOX"] = "invalidAddressPOBox";
    ValidationResponse["ADDRESS_INVALID_SHORT"] = "invalidAddressShort";
    ValidationResponse["AGE_INVALID"] = "invalidAge";
    ValidationResponse["AGE_INVALID_AUTH"] = "invalidAgeAuth";
    ValidationResponse["CITY_INVALID_LONG"] = "invalidCityLong";
    ValidationResponse["CITY_INVALID_SHORT"] = "invalidCityShort";
    ValidationResponse["DATE_INVALID"] = "invalidDate";
    ValidationResponse["EMAIL_INVALID"] = "invalidEmail";
    ValidationResponse["EMAIL_INVALID_LONG"] = "invalidEmailLong";
    ValidationResponse["EMAIL_WARNING_TYPO"] = "emailWarningTypo";
    ValidationResponse["EMAIL_INVALID_SAME"] = "emailInvalidSame";
    ValidationResponse["EMPTY"] = "empty";
    ValidationResponse["FIRSTNAME_INVALID_SHORT"] = "invalidFNShort";
    ValidationResponse["FULL_SSN_INVALID"] = "invalidSSN";
    ValidationResponse["FULL_SSN_INVALID_NOMATCH"] = "invalidSSNMatch";
    ValidationResponse["FULL_SSN_SHORT"] = "FullSsnShort";
    ValidationResponse["HH_EMAIL_INVALID"] = "invalidHhEmail";
    ValidationResponse["INVALID_PIN"] = "invalidPin";
    ValidationResponse["INVALID_PIN_NOMATCH"] = "invalidPinNoMatch";
    ValidationResponse["LASTNAME_INVALID_SHORT"] = "invalidLNShort";
    ValidationResponse["LAST_FOUR_INVALID_NOMATCH"] = "invalidSSNMatchLastFour";
    ValidationResponse["LAST_FOUR_SSN_SHORT"] = "LastFourSsnShort";
    ValidationResponse["NAME_INVALID"] = "invalidName";
    ValidationResponse["NAME_INVALID_LONG"] = "invalidNameLong";
    ValidationResponse["PHONE_NUMBER_INVALID"] = "invalidPhoneNumber";
    ValidationResponse["ROUTING_NUMBER_INVALID"] = "invalidRoutingNum";
    ValidationResponse["STATE_INVALID_RESTRICTED"] = "restrictedState";
    ValidationResponse["STATE_INVALID"] = "invalidState";
    ValidationResponse["PHONE_INVALID"] = "invalidPhone";
    ValidationResponse["VALID"] = "valid";
    ValidationResponse["ZIP_INVALID"] = "invalidZip";
})(ValidationResponse || (exports.ValidationResponse = ValidationResponse = {}));
